"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiOutlinedInput = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
exports.MuiOutlinedInput = {
    styleOverrides: {
        root: {
            borderRadius: global_1.borderRadius.input,
            "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "2px solid " + colors_1.colors.Primary,
            },
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                border: "2px solid " + colors_1.colors.Error,
            },
        },
        notchedOutline: {
            "> legend > span": {
                fontSize: "0.75rem",
            },
        },
        colorSecondary: {
            background: colors_1.colors.White,
            ".MuiOutlinedInput-notchedOutline": {
                border: "1px solid " + colors_1.colors.Primary,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "2px solid " + colors_1.colors.Primary,
            },
        },
    },
};
//# sourceMappingURL=outlined-input.js.map